import { NetFetch } from '../Net/NetFetch';
import { UnauthorizedError } from './Error/UnauthorizedError';
import { StatusCodes } from './Status/StatusCodes';
/**
 * OfficeReport API helper.
 */
export class OfficeReport {
    /**
     * Available external receivers — feeds the AROC-report receiver dropdown.
     * Returns an empty array on any non-OK response (UNAUTHORIZED still throws).
     */
    static async getReceivers() {
        var _a;
        const result = await NetFetch.getData('/json/officereport/receivers');
        if (result && result.statusCode) {
            switch (result.statusCode) {
                case StatusCodes.OK:
                    return (_a = (result.list)) !== null && _a !== void 0 ? _a : [];
                case StatusCodes.UNAUTHORIZED:
                    throw new UnauthorizedError();
            }
        }
        return [];
    }
    /**
     * Vehicles that have at least one non-deleted sighting in the given
     * year/semester/organization range. Used by the AROC boat picker so the
     * dropdown only lists boats the user can actually report on for that
     * period. Empty filter returns every vehicle with any sighting.
     */
    static async getUsedVehicles(filter = {}) {
        var _a;
        const params = new URLSearchParams();
        if (filter.year !== undefined && filter.year > 0) {
            params.set('year', `${filter.year}`);
        }
        if (filter.semester === 1 || filter.semester === 2) {
            params.set('semester', `${filter.semester}`);
        }
        if (filter.organizationId !== undefined && filter.organizationId > 0) {
            params.set('organization_id', `${filter.organizationId}`);
        }
        const query = params.toString();
        const url = query === ''
            ? '/json/officereport/used_vehicles'
            : `/json/officereport/used_vehicles?${query}`;
        const result = await NetFetch.getData(url);
        if (result && result.statusCode) {
            switch (result.statusCode) {
                case StatusCodes.OK:
                    return (_a = (result.list)) !== null && _a !== void 0 ? _a : [];
                case StatusCodes.UNAUTHORIZED:
                    throw new UnauthorizedError();
            }
        }
        return [];
    }
}
